import { ReactNode } from 'react';
import { Users } from 'lucide-react';

export interface Tab {
  id: string;
  label: string;
  href?: string;
}

interface ProfilesHeaderProps {
  tabs?: Tab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  children?: ReactNode;
}

export function ProfilesHeader({ tabs, activeTab, onTabChange, children }: ProfilesHeaderProps) {
  const handleTabClick = (tab: Tab) => {
    if (tab.href) {
      location.href = tab.href;
    } else if (onTabChange) {
      onTabChange(tab.id);
    }
  };

  return (
    <div>
      <div className="flex items-center mb-6">
        <Users className="mr-3 text-action-blue" size={24} />
        <h1 className="text-2xl font-bold text-gray-900">Profiles</h1>
      </div>
      {tabs && (
        <nav className="flex flex-wrap space-x-0 border-b border-gray-200 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              className={`px-4 py-3 text-sm font-medium transition-colors border-b-2 whitespace-nowrap ${
                activeTab === tab.id
                  ? 'border-action-blue text-action-blue'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      )}
      {children && (
        <div>
          {children}
        </div>
      )}
    </div>
  );
}

